import React, { useState } from 'react';
import classNames from 'classnames';
import { Button } from '@fx-ui/fine-design';
import { ValidateInput, ValidateInputProps } from '@fx-ui/jdy-design-biz';
import { isEmpty, trim } from '~/utils';
import Intl from '@fx-ui/intl';
import { EMPTY_FN } from '~/constants';

interface ITextEditingProps extends ValidateInputProps {
    className?: string;
    style?: React.CSSProperties;
    prefixText?: string;
    inputWidth?: number;
    defaultValue?: string;
    placeholder?: string;
    onSave?: (value: string) => Promise<any>;
    onCancel?: () => void;
}

/**
 * 文案在线编辑（可以带有固定前缀 prefixText）
 * @param props ITextEditingProps
 */
const TextEditing: React.FC<ITextEditingProps> = (props) => {
    const {
        className,
        style,
        prefixText,
        inputWidth = 600,
        defaultValue = '',
        validators,
        onSave,
        onCancel = EMPTY_FN
    } = props;

    const [value, setValue] = useState<string>(defaultValue);
    const [saving, setSaving] = useState<boolean>(false);
    const [isInputValid, setIsInputValid] = useState<boolean>(!isEmpty(validators));

    return (
        <div className={classNames('fx-text-editing', className)} style={style}>
            {prefixText && <div className="prefix-text">{prefixText}</div>}
            <div className="input-area" style={{ width: inputWidth }}>
                <ValidateInput
                    validators={validators}
                    style={{ width: '100%' }}
                    inputClassName="text-input"
                    value={value}
                    onChange={(value, isValid) => {
                        setValue(value);
                        setIsInputValid(isValid);
                    }}
                    autoSelect
                />
            </div>
            <Button
                key="ok"
                className="ok-btn"
                type="primary"
                disabled={!isInputValid}
                loading={saving}
                onClick={() => {
                    if (isInputValid && onSave) {
                        setSaving(true);
                        onSave(trim(value)).finally(() => {
                            setSaving(false);
                        });
                    }
                }}
            >
                {Intl.get('ok')}
            </Button>
            <Button key="cancel" className="cancel-btn" type="negative" onClick={onCancel}>
                {Intl.get('cancel')}
            </Button>
        </div>
    );
};

export default TextEditing;
